
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new/books/sorting/rating",
      function () {
        return require("private-next-pages/new/books/sorting/rating/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new/books/sorting/rating"])
      });
    }
  